import { render } from "./SignUpMain.vue?vue&type=template&id=6bcc5afc&scoped=true&ts=true"
import script from "./SignUpMain.vue?vue&type=script&lang=ts"
export * from "./SignUpMain.vue?vue&type=script&lang=ts"

import "./SignUpMain.vue?vue&type=style&index=0&id=6bcc5afc&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcc5afc"]])

export default __exports__